import React from "react"
import LoadingButton from "@mui/lab/LoadingButton"

// Переиспользуемые градиентные стили кнопок турнира.
// hover-градиент реализован через псевдоэлемент ::before с плавным появлением.
const withHoverGradient = (base, hover) => ({
  background: base,
  mt: 2,
  zIndex: 0,
  "&::before": {
    content: '""',
    borderRadius: "inherit",
    position: "absolute",
    inset: 0,
    background: hover,
    opacity: 0,
    transition: "opacity 250ms cubic-bezier(0.4, 0, 0.2, 1)",
    zIndex: -1,
  },
  "&:hover::before": {
    opacity: 1,
  },
  "&[disabled]": {
    background: "inherit",
    border: "1px solid #333",
    cursor: "not-allowed",
  },
})

export const ORANGE_BUTTON_SX = withHoverGradient(
  "linear-gradient(135deg, #FF6B00, #C13D00)",
  "linear-gradient(135deg, rgb(230,85,0), rgb(160,45,0))",
)

export const GREEN_BUTTON_SX = withHoverGradient(
  "linear-gradient(135deg, #39FF14, #1E9600)",
  "linear-gradient(135deg, #2bb80e, #146b00)",
)

/**
 * Единая кнопка действия турнира. Показывает одно из трёх состояний:
 *  - "Connect wallet"  — если кошелёк не подключён;
 *  - "Play Now"        — если пользователь уже участвует;
 *  - "Join Tournament" — если ещё не участвует.
 *
 * @param {object} props
 * @param {object} props.tournament - Объект турнира (нужен participation).
 * @param {object} props.user - Текущий пользователь (нужен address).
 * @param {Function} props.onConnect - Колбэк подключения кошелька.
 * @param {Function} props.onJoin - Колбэк открытия диалога присоединения.
 * @param {Function} props.onPlay - Колбэк открытия игрового диалога.
 * @param {boolean} [props.fullWidth=true]
 * @param {object} [props.sx] - Доп. стили, мёржатся поверх базовых.
 */
export const TournamentActionButton = ({
  tournament,
  user,
  onConnect,
  onJoin,
  onPlay,
  fullWidth = true,
  sx,
}) => {
  const handleClick = (handler) => (event) => {
    event.stopPropagation()
    handler?.()
  }

  if (!user?.address) {
    return (
      <LoadingButton
        variant="contained"
        size="large"
        fullWidth={fullWidth}
        sx={{ ...ORANGE_BUTTON_SX, ...sx }}
        onClick={handleClick(onConnect)}
      >
        Connect wallet
      </LoadingButton>
    )
  }

  if (tournament?.participation) {
    return (
      <LoadingButton
        variant="contained"
        size="large"
        fullWidth={fullWidth}
        disabled={tournament?.is_banned}
        sx={{ ...GREEN_BUTTON_SX, ...sx }}
        onClick={handleClick(onPlay)}
      >
        Play Now
      </LoadingButton>
    )
  }

  return (
    <LoadingButton
      variant="contained"
      size="large"
      fullWidth={fullWidth}
      disabled={tournament?.is_banned}
      sx={{ ...ORANGE_BUTTON_SX, ...sx }}
      onClick={handleClick(onJoin)}
    >
      Join Tournament
    </LoadingButton>
  )
}
